import { Divider, Header } from 'semantic-ui-react'
import React from 'react'
import { OpeningCard } from './Cards/OpeningCard'
import { Section } from '../Shared/Section'

const MyParkSection = () => {
    return (
      <>
          <Divider horizontal>
              <Header as="h4" color="teal">
                  Mon parc
              </Header>
          </Divider>

          <Section>
              <OpeningCard />
          </Section>
      </>
    )
}

export { MyParkSection }
